import { render, staticRenderFns } from "./MultiLangFormSection.vue?vue&type=template&id=e87b8616&scoped=true"
import script from "./MultiLangFormSection.vue?vue&type=script&lang=js"
export * from "./MultiLangFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87b8616",
  null
  
)

export default component.exports